import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={32} height={32} fill="none" {...props}>
    <Path
      fill="#000"
      d="M11.648 26.61v-1.232h3.743v-6.12c-1.92-.294-3.425-1.123-4.517-2.487-1.091-1.364-1.637-2.955-1.637-4.773v-6.62h13.539v6.62c0 1.818-.548 3.409-1.644 4.773-1.096 1.364-2.599 2.193-4.51 2.487v6.12h3.744v1.231h-8.718ZM16 18.044c1.41 0 2.64-.522 3.693-1.567s1.656-2.334 1.81-3.869H10.498c.16 1.536.764 2.826 1.814 3.87S14.59 18.045 16 18.045Zm-5.532-6.667h11.077V6.61H10.468v4.77Z"
    />
  </Svg>
);
export default SvgComponent;
